/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect, useContext, useCallback } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  IconButton,
  CircularProgress,
  Button,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Chip,
  Tooltip,
  Checkbox,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Collapse,
  Divider,
} from '@mui/material';
import {
  Close,
  Edit,
  Public,
  Lock,
  Group,
  Category,
  PlaylistPlay,
  Save,
  CheckCircle,
  ExpandMore,
  ExpandLess,
  Title as TitleIcon,
  Description as DescriptionIcon,
  Category as CategoryIcon,
  Visibility as VisibilityIcon,
  Refresh as RefreshIcon,
  Delete,
  Add,
} from '@mui/icons-material';
import { endpoints, dataFetcher, axios, baseUrl } from 'Api';
import CreateCategoryPage from 'Pages/private/content-layout/CreateCategory';
import { AppContext } from 'Context';
import { useNavigate } from 'react-router-dom';
import styles from './MultipleVideoUploadModal.module.css';

const MultipleVideoEditModal = ({
  open,
  onClose,
  videoIds = [],
  selectedItems,
  onSaveSuccess = null,
}) => {
  const { userDetails, setAppSnackbar, setShowAddPlaylistModal, playlistRefreshTrigger, newlyCreatedPlaylistId, setNewlyCreatedPlaylistId, setShowAddSubCategoryModal, subCategoryRefreshTrigger, newlyCreatedSubCategoryId, setNewlyCreatedSubCategoryId } = useContext(AppContext);
  const navigate = useNavigate();

  // State for all videos
  const [videos, setVideos] = useState([]);
  const [expandedVideos, setExpandedVideos] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  // Toolbar dialog states
  const [applyCategoryDialogOpen, setApplyCategoryDialogOpen] = useState(false);
  const [selectedCategoryForAll, setSelectedCategoryForAll] = useState('');
  const [applyVisibilityDialogOpen, setApplyVisibilityDialogOpen] = useState(false);
  const [selectedVisibilityForAll, setSelectedVisibilityForAll] = useState('2');

  // Global data states
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [playlists, setPlaylists] = useState([]);
  const [groups, setGroups] = useState([]);
  const [groupsLoaded, setGroupsLoaded] = useState(false);
  const [showCreateCategoryModal, setShowCreateCategoryModal] = useState(false);
  const [pendingVideoIdForCategory, setPendingVideoIdForCategory] = useState(null);
  const [pendingVideoIdForSubCategory, setPendingVideoIdForSubCategory] = useState(null);
  const [pendingVideoIdForPlaylist, setPendingVideoIdForPlaylist] = useState(null);
function parseThumbnails(value) {
  if (!value) return []; // No value → empty array
  try {
    // If it's a string, try JSON.parse
    if (typeof value === 'string') {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [parsed];
    }
    // Already an array
    if (Array.isArray(value)) return value;

    // Anything else → wrap in array
    return [value];
  } catch (e) {
    console.error('Error parsing thumbnails:', e);
    return [];
  }
}
  // Map selectedItems to videos state when modal opens
  useEffect(() => {
    if (!open || !selectedItems || selectedItems.length === 0) return;

    const videosData = selectedItems.map((item) => {
      // Parse group_ids if it's a string
      let selectedGroups = [];
if (item?.group_ids) {
  try {
    let groupIds;

    if (typeof item.group_ids === 'string') {
      // If it's comma-separated (e.g. "84,151,179"), split it
      if (item.group_ids.includes(',')) {
        groupIds = item.group_ids.split(',').map((id) => id.trim());
      } else {
        // Try JSON parse if it's a valid JSON array string
        try {
          groupIds = JSON.parse(item.group_ids);
        } catch {
          // Fallback to single value
          groupIds = [item.group_ids];
        }
      }
    } else {
      // Already an array
      groupIds = item.group_ids;
    }

    console.log('groupIds', groupIds);
    selectedGroups = Array.isArray(groupIds) ? groupIds : [];
  } catch (e) {
    console.error('Error parsing group IDs for video:', item.title || item.id, e);
    selectedGroups = [];
  }
}
      console.log('item', item);

      // Parse playlist_id if it's a string - convert to numbers to match API format
let selectedPlaylists = []; // use let here, not const

if (item.playlist_ids) {
  try {
    let playlistIds;

    if (typeof item.playlist_ids === 'string') {
      if (item.playlist_ids.trim().startsWith('[')) {
        playlistIds = JSON.parse(item.playlist_ids);
      } else {
        playlistIds = item.playlist_ids.split(',').map((id) => Number(id.trim()));
      }
    } else {
      playlistIds = item.playlist_ids;
    }

    // Ensure all IDs are numbers to match API format
    const rawIds = Array.isArray(playlistIds) ? playlistIds : [playlistIds];
    selectedPlaylists = rawIds.map((id) => Number(id)).filter((id) => !Number.isNaN(id));
  } catch (e) {
    selectedPlaylists = item.playlist_ids
      ? item.playlist_ids.split(',').map((id) => Number(id.trim())).filter((id) => !Number.isNaN(id))
      : [];
  }
}

      // Parse thumbnails if it's a string
let thumbnails = parseThumbnails(item.thumbnail_list);
      // if (item.thumbnails) {
      //   try {
      //     const thumbnailArray = typeof item.thumbnails === 'string'
      //         ? JSON.parse(item.thumbnails)
      //         : item.thumbnails;
      //     thumbnails = Array.isArray(thumbnailArray) ? thumbnailArray : [];
      //   } catch (e) {
      //     console.error('Error parsing thumbnails:', e);
      //     thumbnails = [];
      //   }
      // }

      // If no thumbnails were parsed, use the main thumbnail as fallback
      if (thumbnails.length === 0 && item.thumbnail) {
        thumbnails = [item.thumbnail];
      }

      // Find the index of the currently selected thumbnail
      const currentThumbIndex = thumbnails.findIndex(
        (thumb) => thumb === item.thumbnail
      );
      const selectedThumbnailIndex = currentThumbIndex !== -1 ? currentThumbIndex : 0;
      console.log('parseThumbnails', parseThumbnails(item.thumbnail_list), item.thumbnail_list);

      return {
        id: item.content_id || item.id,
        draft_id: item.draft_id || '',
        title: item.title || '',
        description: item.description || '',
        visibility: item.visibility || '2',
        selectedCategory: {
          value: item.category_id || '',
          name: item.category || '',
        },
        selectedSubCategory: item.subcategory_id || '',
        selectedPlaylists,
        selectedGroups,
        thumbnail: item.thumbnail || '',
        thumbnails,
        selectedThumbnail: selectedThumbnailIndex,
        size: item.video_size || 0,
        duration: item.video_duration || item.content_duration || 0,
        // Store original values for change detection
        original: {
          title: item.title || '',
          visibility: item.visibility || '2',
          categoryId: item.category_id || '',
          groupIds: selectedGroups,
        },
      };
    });
    setVideos(videosData);
  }, [open, selectedItems]);

  // Fetch categories, subcategories, playlists, groups
  useEffect(() => {
    const fetchAllData = async () => {
      if (!open) return;

      setGroupsLoaded(false);

      try {
        // Fetch categories
        const categoriesResponse = await dataFetcher(endpoints.getMyCategories);
        if (categoriesResponse.success && categoriesResponse.data) {
          // Sort categories to always show "All Videos" at the top
          const sortedCategories = [...categoriesResponse.data].sort((a, b) => {
            const aIsAllVideos = a.title?.toLowerCase() === 'all videos';
            const bIsAllVideos = b.title?.toLowerCase() === 'all videos';
            if (aIsAllVideos && !bIsAllVideos) return -1;
            if (!aIsAllVideos && bIsAllVideos) return 1;
            return 0; // Keep original order for other categories
          });
          setCategories(sortedCategories);
        }

        // Fetch subcategories
        const subCategoriesResponse = await dataFetcher(
          endpoints.getMySubCategory
        );
        if (subCategoriesResponse.success && subCategoriesResponse.data) {
          setSubCategories(subCategoriesResponse.data);
        }

        // Fetch playlists
        const playlistsResponse = await dataFetcher(endpoints.getMyPlaylist);
        if (playlistsResponse.success && playlistsResponse.data) {
          setPlaylists(playlistsResponse.data);
        }

        // Fetch groups
        const groupsResponse = await dataFetcher(endpoints.getMyGroups);
        if (groupsResponse.success && groupsResponse.data) {
          setGroups(groupsResponse.data);
        } else if (
          !groupsResponse.success
          && groupsResponse.message === 'No Groups found'
        ) {
          setGroups([]);
        }
        setGroupsLoaded(true);
      } catch (error) {
        console.error('Error fetching data:', error);
        setGroups([]);
        setGroupsLoaded(true);
      }
    };

    fetchAllData();
  }, [open]);

  // Refresh playlists when a new playlist is created from the global modal
  useEffect(() => {
    if (playlistRefreshTrigger > 0 && open) {
      const refreshPlaylists = async () => {
        try {
          const playlistsResponse = await dataFetcher(endpoints.getMyPlaylist);
          if (playlistsResponse.success && playlistsResponse.data) {
            setPlaylists(playlistsResponse.data);
            // Auto-select the newly created playlist by finding it in fetched data
            if (newlyCreatedPlaylistId && pendingVideoIdForPlaylist) {
              // Find the playlist in the fetched data to get exact ID type
              const newPlaylist = playlistsResponse.data.find(
                (p) => String(p.id) === String(newlyCreatedPlaylistId)
              );
              if (newPlaylist) {
                setVideos((prevVideos) => prevVideos.map((video) => {
                  if (video.id === pendingVideoIdForPlaylist) {
                    const currentPlaylists = video.selectedPlaylists || [];
                    // Check if already exists
                    if (currentPlaylists.includes(newPlaylist.id)) {
                      return video;
                    }
                    return {
                      ...video,
                      selectedPlaylists: [...currentPlaylists, newPlaylist.id],
                    };
                  }
                  return video;
                }));
              }
              setNewlyCreatedPlaylistId(null);
              setPendingVideoIdForPlaylist(null);
            }
          }
        } catch (error) {
          console.error('Error refreshing playlists:', error);
        }
      };
      refreshPlaylists();
    }
  }, [playlistRefreshTrigger, open]);

  // Refresh subcategories when a new subcategory is created from the global modal
  useEffect(() => {
    if (subCategoryRefreshTrigger > 0 && open) {
      const refreshSubCategories = async () => {
        try {
          const subCategoriesResponse = await dataFetcher(endpoints.getMySubCategory);
          if (subCategoriesResponse.success && subCategoriesResponse.data) {
            setSubCategories(subCategoriesResponse.data);
            // Auto-select the newly created subcategory only for the video that triggered the modal
            if (newlyCreatedSubCategoryId && pendingVideoIdForSubCategory) {
              // Convert to number to match the type from API
              const newSubCategoryId = typeof newlyCreatedSubCategoryId === 'string'
                ? parseInt(newlyCreatedSubCategoryId, 10)
                : newlyCreatedSubCategoryId;
              setVideos((prevVideos) => prevVideos.map((video) => {
                if (video.id === pendingVideoIdForSubCategory) {
                  return {
                    ...video,
                    selectedSubCategory: newSubCategoryId,
                  };
                }
                return video;
              }));
              setNewlyCreatedSubCategoryId(null);
              setPendingVideoIdForSubCategory(null);
            }
          }
        } catch (error) {
          console.error('Error refreshing subcategories:', error);
        }
      };
      refreshSubCategories();
    }
  }, [subCategoryRefreshTrigger, open]);

  // Handle category creation callback - refresh list and select new category for the video
  const handleCategoryCreated = async () => {
    try {
      const categoriesResponse = await dataFetcher(endpoints.getMyCategories);
      if (categoriesResponse.success && categoriesResponse.data) {
        // Sort categories to always show "All Videos" at the top
        const sortedCategoriesForDisplay = [...categoriesResponse.data].sort((a, b) => {
          const aIsAllVideos = a.title?.toLowerCase() === 'all videos';
          const bIsAllVideos = b.title?.toLowerCase() === 'all videos';
          if (aIsAllVideos && !bIsAllVideos) return -1;
          if (!aIsAllVideos && bIsAllVideos) return 1;
          return 0; // Keep original order for other categories
        });
        setCategories(sortedCategoriesForDisplay);
        // Select the most recently created category (last in the list by id)
        const sortedCategories = [...categoriesResponse.data].sort((a, b) => b.id - a.id);
        if (sortedCategories.length > 0 && pendingVideoIdForCategory) {
          const newestCategory = sortedCategories[0];
          if (pendingVideoIdForCategory === '__all__') {
            // Apply to all videos
            setVideos((prevVideos) => prevVideos.map((video) => ({
              ...video,
              selectedCategory: {
                value: newestCategory.id,
                name: newestCategory.title,
              },
            })));
          } else {
            // Update the specific video's category
            setVideos((prevVideos) => prevVideos.map((video) => {
              if (video.id === pendingVideoIdForCategory) {
                return {
                  ...video,
                  selectedCategory: {
                    value: newestCategory.id,
                    name: newestCategory.title,
                  },
                };
              }
              return video;
            }));
          }
        }
      }
    } catch (error) {
      console.error('Error refreshing categories:', error);
    } finally {
      setPendingVideoIdForCategory(null);
      setShowCreateCategoryModal(false);
    }
  };

  const updateVideo = useCallback(
    (videoId, updates) => {
      setVideos((prevVideos) => prevVideos.map((video) => {
          if (video.id === videoId) {
            const updatedVideo = { ...video, ...updates };
            // If selectedThumbnail is updated, update the thumbnail field
            if (
              'selectedThumbnail' in updates
              && video.thumbnails
              && video.thumbnails[updates.selectedThumbnail]
            ) {
              updatedVideo.thumbnail = video.thumbnails[updates.selectedThumbnail];
            }
            return updatedVideo;
          }
          return video;
        }));

      // Auto-expand if visibility is changed to Group but no groups selected
      if (updates.visibility === '3') {
        const video = videos.find((v) => v.id === videoId);
        if (!video?.selectedGroups || video.selectedGroups.length === 0) {
          setExpandedVideos((prev) => ({
            ...prev,
            [videoId]: true,
          }));
        }
      }
    },
    [videos]
  );

  const toggleExpanded = useCallback((videoId) => {
    setExpandedVideos((prev) => ({
      ...prev,
      [videoId]: !prev[videoId],
    }));
  }, []);

  const removeVideo = useCallback((videoId) => {
    setVideos((prevVideos) => prevVideos.filter((video) => video.id !== videoId));
  }, []);

  const handleClose = useCallback(() => {
    // Reset state
    setVideos([]);
    setIsLoading(false);
    setIsSaving(false);

    onClose();
  }, [onClose]);

  const handleSaveAll = async () => {
    if (videos.length === 0) return;

    // Validate group selection for videos with Group visibility
    const invalidVideos = videos.filter(
      (video) => video.visibility === '3'
        && (!video.selectedGroups || video.selectedGroups.length === 0)
    );

    setIsSaving(true);

    try {
      const apiUrl = `${baseUrl}${endpoints.bulkEdit}`;

      // Get token from localStorage
      const token = localStorage.getItem('token');

      // Build data array with all fields
      const data = videos.map((video) => {
        const videoData = {
          draft_id: video.draft_id || '',
        };

        // Add title if changed
        if (video.title !== video.original.title) {
          videoData.title = video.title;
        }

        // Add visibility if changed
        if (video.visibility !== video.original.visibility) {
          videoData.visibility = video.visibility;
        }

        // Add categoryId if changed
        if (video.selectedCategory.value !== video.original.categoryId) {
          videoData.category_id = video.selectedCategory.value;
        }
        // Always add description
        videoData.description = video.description || '';
        // videoData.thumbnail = video.selectedThumbnail;
                videoData.thumbnail = video?.thumbnails[video.selectedThumbnail] || '';
        // Always add playlist_ids (array format)
        videoData.playlist_ids = video.selectedPlaylists.join(',') || '';
 videoData.group_ids = video.selectedGroups.join(',') || '';
        // Always add group_id as comma-separated string
        // videoData.group_id = (video.selectedGroups && video.selectedGroups.length > 0)
        //   ? video.selectedGroups.join(',')
        //   : '';

        return videoData;
      });

      // Send bulk edit request
      const response = await axios.post(apiUrl, {
        token,
        data,
      });

      if (response.data?.success) {
        setAppSnackbar({
          open: true,
          message: `Successfully updated ${videos.length} video(s)`,
          severity: 'success',
        });

        if (onSaveSuccess) {
          onSaveSuccess(response.data);
        }
      } else {
        setAppSnackbar({
          open: true,
          message: response.data?.message || 'Failed to update videos',
          severity: 'error',
        });
      }
    } catch (error) {
      console.error('Error updating videos:', error);
      setAppSnackbar({
        open: true,
        message: error.response?.data?.message || 'Error updating videos',
        severity: 'error',
      });
    } finally {
      setIsSaving(false);
      handleClose();
    }
  };

  const getVisibilityIcon = (visibility) => {
    switch (visibility) {
      case '1':
        return <Lock style={{ fontSize: 16, color: '#EF4444' }} />;
      case '3':
        return <Group style={{ fontSize: 16, color: '#8B5CF6' }} />;
      default:
        return <Public style={{ fontSize: 16, color: '#10B981' }} />;
    }
  };

  const getVisibilityText = (visibility) => {
    switch (visibility) {
      case '1':
        return 'Private';
      case '3':
        return 'Group';
      default:
        return 'All Viewers';
    }
  };

  // Toolbar handlers
  const handleClearAllTitles = useCallback(() => {
    setVideos((prevVideos) => prevVideos.map((video) => ({
        ...video,
        title: '',
      })));
  }, []);

  const handleClearAllDescriptions = useCallback(() => {
    setVideos((prevVideos) => prevVideos.map((video) => ({
        ...video,
        description: '',
      })));
  }, []);

  const handleApplyCategoryToAll = useCallback(() => {
    if (selectedCategoryForAll) {
      const selectedCat = categories.find(
        (cat) => cat.id === selectedCategoryForAll
      );
      if (selectedCat) {
        setVideos((prevVideos) => prevVideos.map((video) => ({
            ...video,
            selectedCategory: {
              value: selectedCat.id,
              name: selectedCat.title,
            },
          })));
        setApplyCategoryDialogOpen(false);
        setSelectedCategoryForAll('');
      }
    }
  }, [selectedCategoryForAll, categories]);

  const handleApplyVisibilityToAll = useCallback(() => {
    setVideos((prevVideos) => prevVideos.map((video) => ({
        ...video,
        visibility: selectedVisibilityForAll,
        // Clear groups if not group visibility
        selectedGroups:
          selectedVisibilityForAll === '3' ? video.selectedGroups : [],
      })));
    // If setting to group visibility, expand all videos to show group selection
    if (selectedVisibilityForAll === '3') {
      const expandedState = {};
      videos.forEach((video) => {
        expandedState[video.id] = true;
      });
      setExpandedVideos(expandedState);
    }
    setApplyVisibilityDialogOpen(false);
  }, [selectedVisibilityForAll, videos]);

  const handleResetAll = useCallback(() => {
    if (!selectedItems || selectedItems.length === 0) return;

    const resetVideosData = selectedItems.map((item) => {
      // Parse group_ids if it's a string
      let selectedGroups = [];
      if (item.group_ids) {
        try {
          const groupIds = typeof item.group_ids === 'string'
              ? JSON.parse(item.group_ids)
              : item.group_ids;
          selectedGroups = Array.isArray(groupIds) ? groupIds : [];
        } catch (e) {
          selectedGroups = [];
        }
      }

      // Parse playlist_id if it's a string
      let selectedPlaylists = [];
      if (item.playlist_id) {
        try {
          const playlistIds = typeof item.playlist_id === 'string'
              ? JSON.parse(item.playlist_id)
              : item.playlist_id;
          selectedPlaylists = Array.isArray(playlistIds)
            ? playlistIds
            : [playlistIds];
        } catch (e) {
          // If parsing fails, treat it as a single playlist ID
          selectedPlaylists = item.playlist_id ? [item.playlist_id] : [];
        }
      }

      // Parse thumbnails if it's a string
      let thumbnails = [];
      if (item.thumbnails) {
        try {
          const thumbnailArray = typeof item.thumbnails === 'string'
              ? JSON.parse(item.thumbnails)
              : item.thumbnails;
          thumbnails = Array.isArray(thumbnailArray) ? thumbnailArray : [];
        } catch (e) {
          thumbnails = [];
        }
      }

      // If no thumbnails were parsed, use the main thumbnail as fallback
      if (thumbnails.length === 0 && item.thumbnail) {
        thumbnails = [item.thumbnail];
      }

      // Find the index of the currently selected thumbnail
      const currentThumbIndex = thumbnails.findIndex(
        (thumb) => thumb === item.thumbnail
      );
      const selectedThumbnailIndex = currentThumbIndex !== -1 ? currentThumbIndex : 0;

      return {
        id: item.content_id || item.id,
        draft_id: item.draft_id || '',
        title: item.title || '',
        description: item.description || '',
        visibility: item.visibility || '2',
        selectedCategory: {
          value: item.category_id || '',
          name: item.category || '',
        },
        selectedSubCategory: item.subcategory_id || '',
        selectedPlaylists,
        selectedGroups,
        thumbnail: item.thumbnail || '',
        thumbnails,
        selectedThumbnail: selectedThumbnailIndex,
        size: item.video_size || 0,
        duration: item.video_duration || item.content_duration || 0,
        // Store original values for change detection
        original: {
          title: item.title || '',
          visibility: item.visibility || '2',
          categoryId: item.category_id || '',
          groupIds: selectedGroups,
        },
      };
    });

    setVideos(resetVideosData);
    setExpandedVideos({});
  }, [selectedItems]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 16,
          maxWidth: 1200,
          maxHeight: '90vh',
        },
      }}
    >
      <DialogContent
        style={{ padding: 0, display: 'flex', flexDirection: 'column' }}
      >
        {/* Header */}
        <div className={styles.header}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Edit style={{ color: '#1a1c22', fontSize: 24, marginRight: 12 }} />
            <Typography variant="h6" className={styles.title}>
              Edit Multiple Videos (
{videos.length}
{' '}
selected)
            </Typography>
          </div>
          <IconButton onClick={handleClose} style={{ color: '#6B7280' }} size="large">
            <Close />
          </IconButton>
        </div>

        {/* Content */}
        <div className={styles.content}>
          {isLoading ? (
            <div className={styles.emptyState}>
              <CircularProgress
                size={48}
                style={{ color: '#1a1c22', marginBottom: 16 }}
              />
              <Typography variant="h6" className={styles.processingText}>
                Loading video details...
              </Typography>
              <Typography variant="body2" className={styles.processingSubText}>
                Please wait while we fetch your video information
              </Typography>
            </div>
          ) : videos.length === 0 ? (
            <div className={styles.emptyState}>
              <Edit
                style={{ fontSize: 64, color: '#D1D5DB', marginBottom: 16 }}
              />
              <Typography variant="h6" className={styles.noVideosText}>
                No videos loaded
              </Typography>
              <Typography variant="body2" className={styles.noVideosSubText}>
                Please select videos to edit
              </Typography>
            </div>
          ) : (
            <TableContainer component={Paper} className={styles.tableContainer}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={styles.headerCell}
                      style={{ width: 120 }}
                    >
                      Thumbnail
                    </TableCell>
                    <TableCell
                      className={styles.headerCell}
                      style={{ width: 200 }}
                    >
                      Title
                    </TableCell>
                    {/* <TableCell
                      className={styles.headerCell}
                      style={{ width: 250 }}
                    >
                      Description
                    </TableCell> */}
                    <TableCell
                      className={styles.headerCell}
                      style={{ width: 150 }}
                    >
                      Category
                    </TableCell>
                    {/* <TableCell
                      className={styles.headerCell}
                      style={{ width: 150 }}
                    >
                      Subcategory
                    </TableCell> */}
                    {/* <TableCell
                      className={styles.headerCell}
                      style={{ width: 150 }}
                    >
                      Playlist
                    </TableCell> */}
                    <TableCell
                      className={styles.headerCell}
                      style={{ width: 120 }}
                    >
                      Visibility
                    </TableCell>
                    <TableCell
                      className={styles.headerCell}
                      style={{ width: 80 }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {videos.map((video) => (
                    <React.Fragment key={video.id}>
                      <TableRow className={styles.videoRow}>
                        {/* Thumbnail */}
                        <TableCell>
                          <div className={styles.thumbnailContainer}>
                            {video.thumbnail ? (
                              <img
                                src={video.thumbnail}
                                alt="Thumbnail"
                                className={styles.thumbnail}
                              />
                            ) : (
                              <div className={styles.thumbnailPlaceholder}>
                                <Edit
                                  style={{ fontSize: 24, color: '#9CA3AF' }}
                                />
                              </div>
                            )}
                          </div>
                        </TableCell>

                        {/* Title */}
                        <TableCell>
                          <TextField
                            value={video.title}
                            onChange={(e) => updateVideo(video.id, { title: e.target.value })}
                            variant="outlined"
                            size="small"
                            fullWidth
                            placeholder="Video title"
                            className={styles.titleField}
                          />
                        </TableCell>

                        {/* Category */}
                        <TableCell>
                          <FormControl
                            fullWidth
                            size="small"
                            variant="outlined"
                          >
                            <Select
                              value={video.selectedCategory.value}
                              onChange={(e) => {
                                if (e.target.value === '__create_new__') {
                                  setPendingVideoIdForCategory(video.id);
                                  setShowCreateCategoryModal(true);
                                  return;
                                }
                                const selectedCat = categories.find(
                                  (cat) => cat.id === e.target.value
                                );
                                updateVideo(video.id, {
                                  selectedCategory: {
                                    value: e.target.value,
                                    name: selectedCat?.title || '',
                                  },
                                });
                              }}
                              className={styles.selectField}
                              disabled={categories.length === 0}
                              MenuProps={{
                                PaperProps: {
                                  style: {
                                    maxHeight: 300,
                                  },
                                },
                                anchorOrigin: {
                                  vertical: 'bottom',
                                  horizontal: 'left',
                                },
                                transformOrigin: {
                                  vertical: 'top',
                                  horizontal: 'left',
                                },
                                getContentAnchorEl: null,
                                autoFocus: false,
                                disableAutoFocusItem: true,
                              }}
                            >
                              <MenuItem value="__create_new__">
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: '#1a1c22',
                                  }}
                                >
                                  <Add
                                    style={{
                                      fontSize: 16,
                                      marginRight: 8,
                                      color: '#1a1c22',
                                    }}
                                  />
                                  <span style={{ fontWeight: 600 }}>Create New Category</span>
                                </div>
                              </MenuItem>
                              <Divider style={{ margin: '4px 0' }} />
                              {categories.length === 0 ? (
                                <MenuItem value="">
                                  <em style={{ color: '#9CA3AF' }}>
                                    Loading...
                                  </em>
                                </MenuItem>
                              ) : (
                                categories.map((cat) => (
                                  <MenuItem key={cat.id} value={cat.id}>
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <Category
                                        style={{
                                          fontSize: 16,
                                          marginRight: 8,
                                          color: '#6B7280',
                                        }}
                                      />
                                      {cat.title}
                                    </div>
                                  </MenuItem>
                                ))
                              )}
                            </Select>
                          </FormControl>
                        </TableCell>

                        {/* Visibility */}
                        <TableCell>
                          <Chip
                            icon={getVisibilityIcon(video.visibility)}
                            label={getVisibilityText(video.visibility)}
                            onClick={() => {
                              // Cycle through visibility options
                              const visibilities = ['2', '1', '3']; // Public, Private, Group
                              const currentIndex = visibilities.indexOf(
                                video.visibility
                              );
                              const nextIndex = (currentIndex + 1) % visibilities.length;
                              updateVideo(video.id, {
                                visibility: visibilities[nextIndex],
                              });
                            }}
                            className={styles.visibilityChip}
                            clickable
                          />
                        </TableCell>

                        {/* Action */}
                        <TableCell>
                          <div className={styles.actions}>
                            <Tooltip title="More options">
                              <IconButton
                                size="small"
                                onClick={() => toggleExpanded(video.id)}
                                className={`${styles.expandButton} ${
                                  expandedVideos[video.id]
                                    ? styles.expanded
                                    : ''
                                }`}
                              >
                                {expandedVideos[video.id] ? (
                                  <ExpandLess />
                                ) : (
                                  <ExpandMore />
                                )}
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Remove video">
                              <IconButton
                                size="small"
                                onClick={() => removeVideo(video.id)}
                                className={styles.deleteButton}
                              >
                                <Delete />
                              </IconButton>
                            </Tooltip>
                          </div>
                        </TableCell>
                      </TableRow>

                      {/* Expanded Row for Thumbnails */}
                      <TableRow>
                        <TableCell
                          style={{ paddingBottom: 0, paddingTop: 0 }}
                          colSpan={5}
                        >
                          <Collapse
                            in={expandedVideos[video.id]}
                            timeout={300}
                            unmountOnExit
                          >
                            <div className={styles.expandedContent}>
                              {/* Thumbnail Selection */}
                              {video.thumbnails
                                && video.thumbnails.length > 0 && (
                                  <div className={styles.thumbnailSelection}>
                                    <Typography
                                      variant="subtitle2"
                                      className={styles.sectionTitle}
                                    >
                                    Select Thumbnail
                                    </Typography>
                                    <div className={styles.thumbnailGrid}>
                                      {video.thumbnails.map((thumb, index) => (
                                        <div
                                          key={index}
                                          onClick={() => updateVideo(video.id, {
                                              selectedThumbnail: index,
                                            })}
                                          className={`${
                                            styles.thumbnailGridItem
                                          } ${
                                            video.selectedThumbnail === index
                                              ? styles.selected
                                              : ''
                                          }`}
                                        >
                                          <img
                                            src={thumb}
                                            alt={`Thumbnail ${index + 1}`}
                                          />
                                          {video.selectedThumbnail
                                            === index && (
                                            <div
                                              className={
                                                styles.selectedIndicator
                                              }
                                            >
                                              <CheckCircle
                                                style={{
                                                  fontSize: 16,
                                                  color: 'white',
                                                }}
                                              />
                                            </div>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                )}

                              {/* Additional Fields */}
                              <div className={styles.additionalFieldsContainer}>
                                <div className={styles.additionalFields}>
                                  {/* Description, Subcategory and Playlist in one compact row */}
                                  <div className={styles.compactFieldRow}>
                                    <div className={styles.fieldGroup}>
                                      <Typography
                                        variant="subtitle2"
                                        className={styles.fieldLabel}
                                      >
                                        Description
                                      </Typography>
                                      <TextField
                                        value={video.description}
                                        onChange={(e) => updateVideo(video.id, {
                                            description: e.target.value,
                                          })}
                                        placeholder="Add description..."
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        className={styles.descriptionField}
                                      />
                                    </div>

                                    <div className={styles.fieldGroup}>
                                      <Typography
                                        variant="subtitle2"
                                        className={styles.fieldLabel}
                                      >
                                        Subcategory
                                      </Typography>
                                      <FormControl
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                      >
                                        <Select
                                          value={video.selectedSubCategory}
                                          onChange={(e) => {
                                            if (e.target.value === '__create_new__') {
                                              setPendingVideoIdForSubCategory(video.id);
                                              setShowAddSubCategoryModal(true);
                                              return;
                                            }
                                            updateVideo(video.id, {
                                              selectedSubCategory: e.target.value,
                                            });
                                          }}
                                          className={styles.selectField}
                                          MenuProps={{
                                            PaperProps: {
                                              style: {
                                                maxHeight: 300,
                                              },
                                            },
                                            anchorOrigin: {
                                              vertical: 'bottom',
                                              horizontal: 'left',
                                            },
                                            transformOrigin: {
                                              vertical: 'top',
                                              horizontal: 'left',
                                            },
                                            getContentAnchorEl: null,
                                            autoFocus: false,
                                            disableAutoFocusItem: true,
                                          }}
                                        >
                                          <MenuItem
                                            value="__create_new__"
                                            style={{
                                              position: 'sticky',
                                              top: 0,
                                              backgroundColor: 'white',
                                              zIndex: 1,
                                            }}
                                          >
                                            <div style={{ display: 'flex', alignItems: 'center', color: '#1a1c22' }}>
                                              <Add style={{ fontSize: 16, marginRight: 8, color: '#1a1c22' }} />
                                              <span style={{ fontSize: 13, fontFamily: 'Montserrat', fontWeight: 600 }}>Add New Subcategory</span>
                                            </div>
                                          </MenuItem>
                                          <Divider style={{ margin: '4px 0', position: 'sticky', top: 36, backgroundColor: 'white', zIndex: 1 }} />
                                          <MenuItem value="">None</MenuItem>
                                          {subCategories.map((subcat) => (
                                            <MenuItem
                                              key={subcat.id}
                                              value={subcat.id}
                                            >
                                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Category style={{ fontSize: 15, marginRight: 8, color: '#1a1c22' }} />
                                                <span style={{ fontFamily: 'Montserrat', fontSize: 13 }}>{subcat.title}</span>
                                              </div>
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    </div>

                                    <div className={styles.fieldGroup}>
                                      <Typography
                                        variant="subtitle2"
                                        className={styles.fieldLabel}
                                      >
                                        Playlists
                                      </Typography>
                                      <FormControl
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                      >
                                        <Select
                                          multiple
                                          value={video.selectedPlaylists}
                                          onChange={(e) => {
                                            const { value } = e.target;
                                            // Check if "Add New" was clicked
                                            if (value.includes('__create_new__')) {
                                              setPendingVideoIdForPlaylist(video.id);
                                              setShowAddPlaylistModal(true);
                                              return;
                                            }
                                            // Just use the value directly - Material-UI handles toggle
                                            updateVideo(video.id, {
                                              selectedPlaylists: value,
                                            });
                                          }}
                                          className={styles.selectField}
                                          renderValue={(selected) => {
                                            if (selected.length === 0) {
                                              return (
                                                <em
                                                  style={{ color: '#9CA3AF' }}
                                                >
                                                  Select playlists...
                                                </em>
                                              );
                                            }
                                            return `${
                                              selected.length
                                            } playlist${
                                              selected.length !== 1 ? 's' : ''
                                            } selected`;
                                          }}
                                          displayEmpty
                                          MenuProps={{
                                            PaperProps: {
                                              style: {
                                                maxHeight: 300,
                                              },
                                            },
                                            anchorOrigin: {
                                              vertical: 'bottom',
                                              horizontal: 'left',
                                            },
                                            transformOrigin: {
                                              vertical: 'top',
                                              horizontal: 'left',
                                            },
                                            getContentAnchorEl: null,
                                            autoFocus: false,
                                            disableAutoFocusItem: true,
                                          }}
                                        >
                                          <MenuItem
                                            value="__create_new__"
                                            style={{
                                              position: 'sticky',
                                              top: 0,
                                              backgroundColor: 'white',
                                              zIndex: 1,
                                            }}
                                          >
                                            <div style={{ display: 'flex', alignItems: 'center', color: '#1a1c22' }}>
                                              <Add style={{ fontSize: 16, marginRight: 8, color: '#1a1c22' }} />
                                              <span style={{ fontSize: 13, fontFamily: 'Montserrat', fontWeight: 600 }}>Add New Playlist</span>
                                            </div>
                                          </MenuItem>
                                          <Divider style={{ margin: '4px 0', position: 'sticky', top: 36, backgroundColor: 'white', zIndex: 1 }} />
                                          {playlists.length === 0 ? (
                                            <MenuItem disabled>
                                              <em style={{ color: '#9CA3AF' }}>
                                                No playlists available
                                              </em>
                                            </MenuItem>
                                          ) : (
                                            playlists.map((playlist) => (
                                              <MenuItem
                                                key={playlist.id}
                                                value={playlist.id}
                                              >
                                                <Checkbox
                                                  checked={video.selectedPlaylists.includes(playlist.id)}
                                                  style={{ color: '#1a1c22' }}
                                                />
                                                <div
                                                  style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                  }}
                                                >
                                                  <PlaylistPlay
                                                    style={{
                                                      fontSize: 15,
                                                      marginRight: 8,
                                                      color: '#1a1c22',
                                                    }}
                                                  />
                                                  <span
                                                    style={{
                                                      fontFamily: 'Montserrat',
                                                      fontSize: 13,
                                                      color: '#1f2937',
                                                      fontWeight: 500,
                                                    }}
                                                  >
                                                    {playlist.title}
                                                  </span>
                                                </div>
                                              </MenuItem>
                                            ))
                                          )}
                                        </Select>
                                      </FormControl>
                                    </div>
                                  </div>

                                  {/* Groups (when visibility is Group) */}
                                  {video.visibility === '3' && (
                                    <div className={styles.fieldGroup}>
                                      <Typography
                                        variant="subtitle2"
                                        className={styles.fieldLabel}
                                      >
                                        Select Groups
                                      </Typography>
                                      {!groupsLoaded ? (
                                        <div
                                          className={
                                            styles.loadingContainerWithText
                                          }
                                        >
                                          <CircularProgress
                                            size={16}
                                            style={{ color: '#1a1c22' }}
                                          />
                                          <Typography
                                            variant="body2"
                                            className={styles.loadingText}
                                          >
                                            Loading groups...
                                          </Typography>
                                        </div>
                                      ) : groups.length === 0 ? (
                                        <div
                                          className={`${
                                            styles.emptyGroupsContainer
                                          } ${
                                            video.visibility === '3'
                                              ? styles.emptyGroupsContainerWarning
                                              : ''
                                          }`}
                                        >
                                          <Typography
                                            variant="body2"
                                            className={styles.emptyGroupsText}
                                          >
                                            No groups available
                                          </Typography>
                                        </div>
                                      ) : (
                                        <div
                                          className={`${
                                            styles.groupSelection
                                          } ${
                                            !video.selectedGroups
                                            || video.selectedGroups.length === 0
                                              ? styles.groupSelectionWarning
                                              : ''
                                          }`}
                                        >
                                          {groups.map((group) => (
                                            <FormControlLabel
                                              key={group.id}
                                              control={(
                                                <Checkbox
                                                  checked={video.selectedGroups.includes(
                                                    group.id
                                                  )}
                                                  onChange={(e) => {
                                                    const newGroups = e.target
                                                      .checked
                                                      ? [
                                                          ...video.selectedGroups,
                                                          group.id,
                                                        ]
                                                      : video.selectedGroups.filter(
                                                          (id) => id !== group.id
                                                        );
                                                    updateVideo(video.id, {
                                                      selectedGroups: newGroups,
                                                    });
                                                  }}
                                                  size="small"
                                                  style={{ color: '#8B5CF6' }}
                                                />
                                              )}
                                              label={(
                                                <div
                                                  style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                  }}
                                                >
                                                  <Group
                                                    style={{
                                                      fontSize: 16,
                                                      marginRight: 8,
                                                      color: '#8B5CF6',
                                                    }}
                                                  />
                                                  {group.title}
                                                </div>
                                              )}
                                              className={styles.groupCheckbox}
                                            />
                                          ))}
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </div>

        {/* Footer Actions */}
        {videos.length > 0 && (
          <div className={styles.footer}>
            <div className={styles.footerInfo}>
              <Typography variant="body2" className={styles.footerText}>
                {videos.length}
{' '}
video
{videos.length !== 1 ? 's' : ''}
{' '}
ready to save
              </Typography>
            </div>
            {/* Toolbar Section */}
            <div className={styles.toolbarSection}>
              <Tooltip title="Clear all titles">
                <IconButton
                  size="small"
                  onClick={handleClearAllTitles}
                  className={styles.toolButton}
                >
                  <TitleIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Clear all descriptions">
                <IconButton
                  size="small"
                  onClick={handleClearAllDescriptions}
                  className={styles.toolButton}
                >
                  <DescriptionIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Apply same category to all videos">
                <IconButton
                  size="small"
                  onClick={() => setApplyCategoryDialogOpen(true)}
                  className={styles.toolButton}
                >
                  <CategoryIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Apply same visibility to all videos">
                <IconButton
                  size="small"
                  onClick={() => setApplyVisibilityDialogOpen(true)}
                  className={styles.toolButton}
                >
                  <VisibilityIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Reset all to original values">
                <IconButton
                  size="small"
                  onClick={handleResetAll}
                  className={styles.toolButton}
                >
                  <RefreshIcon />
                </IconButton>
              </Tooltip>
            </div>
            <div className={styles.footerActions}>
              <Button onClick={handleClose} className={styles.cancelButton}>
                Cancel
              </Button>
              <Button
                onClick={handleSaveAll}
                disabled={isSaving}
                variant="contained"
                className={styles.publishButton}
              >
                {isSaving ? (
                  <div className={styles.uploadingContainer}>
                    <CircularProgress
                      size={16}
                      className={styles.uploadingText}
                    />
                    Saving...
                  </div>
                ) : (
                  <div className={styles.uploadButtonContainer}>
                    <Save style={{ fontSize: 18 }} />
                    Save All Changes
                  </div>
                )}
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
      {/* Apply Category Dialog */}
      <Dialog
        open={applyCategoryDialogOpen}
        onClose={() => setApplyCategoryDialogOpen(false)}
      >
        <DialogTitle>Apply Category to All Videos</DialogTitle>
        <DialogContent>
          <FormControl fullWidth style={{ marginTop: 16 }}>
            <Select
              value={selectedCategoryForAll}
              onChange={(e) => {
                if (e.target.value === '__create_new__') {
                  setPendingVideoIdForCategory('__all__');
                  setShowCreateCategoryModal(true);
                  setApplyCategoryDialogOpen(false);
                  return;
                }
                setSelectedCategoryForAll(e.target.value);
              }}
              displayEmpty
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 300,
                  },
                },
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                getContentAnchorEl: null,
                autoFocus: false,
                disableAutoFocusItem: true,
              }}
            >
              <MenuItem value="__create_new__">
                <div style={{ display: 'flex', alignItems: 'center', color: '#1a1c22' }}>
                  <Add
                    style={{ fontSize: 16, marginRight: 8, color: '#1a1c22' }}
                  />
                  <span style={{ fontWeight: 600 }}>Create New Category</span>
                </div>
              </MenuItem>
              <Divider style={{ margin: '4px 0' }} />
              <MenuItem value="" disabled>
                <em>Select a category</em>
              </MenuItem>
              {categories.map((cat) => (
                <MenuItem key={cat.id} value={cat.id}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Category
                      style={{ fontSize: 16, marginRight: 8, color: '#6B7280' }}
                    />
                    {cat.title}
                  </div>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setApplyCategoryDialogOpen(false);
              setSelectedCategoryForAll('');
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleApplyCategoryToAll}
            variant="contained"
            disabled={!selectedCategoryForAll}
            style={{ backgroundColor: '#1a1c22' }}
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
      {/* Apply Visibility Dialog */}
      <Dialog
        open={applyVisibilityDialogOpen}
        onClose={() => setApplyVisibilityDialogOpen(false)}
      >
        <DialogTitle>Apply Visibility to All Videos</DialogTitle>
        <DialogContent>
          <FormControl fullWidth style={{ marginTop: 16 }}>
            <Select
              value={selectedVisibilityForAll}
              onChange={(e) => setSelectedVisibilityForAll(e.target.value)}
            >
              <MenuItem value="2">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Public
                    style={{ fontSize: 16, marginRight: 8, color: '#10B981' }}
                  />
                  All Viewers
                </div>
              </MenuItem>
              <MenuItem value="1">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Lock
                    style={{ fontSize: 16, marginRight: 8, color: '#EF4444' }}
                  />
                  Private
                </div>
              </MenuItem>
              <MenuItem value="3">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Group
                    style={{ fontSize: 16, marginRight: 8, color: '#8B5CF6' }}
                  />
                  Group
                </div>
              </MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setApplyVisibilityDialogOpen(false)}>
            Cancel
          </Button>
          <Button
            onClick={handleApplyVisibilityToAll}
            variant="contained"
            style={{ backgroundColor: '#1a1c22' }}
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
      {/* Create Category Modal */}
      {showCreateCategoryModal && (
        <CreateCategoryPage
          initialOpen={showCreateCategoryModal}
          onModalClose={() => {
            setShowCreateCategoryModal(false);
            setPendingVideoIdForCategory(null);
          }}
          onCategoryCreated={handleCategoryCreated}
        />
      )}
    </Dialog>
  );
};

export default MultipleVideoEditModal;
